import ResourceService from './resource.service'

class ClientGradeService extends ResourceService {
  static get resource() {
    return 'client-grade'
  }
}

export default ClientGradeService
